import React from "react";
import HeroSection from "../components/home/HeroSection";
import FestivalDescription from "../components/home/FestivalDescription";
import FestivalExperience from "../components/home/FestivalExperience";
import PhotoGallery from "../components/home/PhotoGallery";
import ContactSection from "../components/home/ContactSection";
import FAQSection from "../components/home/FAQSection";
import CTASection from "../components/home/CTASection";
import ArtistsSection from "../components/home/ArtistsSection";
import GastronomySection from "../components/home/GastronomySection";
import UniqueExperienceSection from "../components/home/UniqueExperienceSection";

const Home: React.FC = () => {
  return (
    <>
      <HeroSection />
      <ArtistsSection />
      <GastronomySection />
      <UniqueExperienceSection />
      <FestivalDescription />
      <FestivalExperience />
      <PhotoGallery />
      <CTASection />
      <FAQSection />
      <ContactSection />
    </>
  );
};

export default Home;
